// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer utilities {
  .simple-keyboard.japanese-left {
    width: 240px !important;
  }

  .simple-keyboard.japanese-right {
    width: 240px !important;
    /* Tall enough for the 5-row segment-navigation layout, so switching in and
       out of it doesn't resize (and jump) the whole keyboard. */
    min-height: 360px;
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows {
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row {
    gap: 2px;
    height: 100%;
    display: grid;
    margin-bottom: 0;
  }

  .simple-keyboard.fb-keyboard.japanese-middle.numbers .hg-rows .hg-row {
    grid-template-columns: repeat(5, minmax(0, 1fr)) 2px repeat(3, minmax(0, 1fr));
  }

  .simple-keyboard.fb-keyboard.japanese-middle.abc .hg-rows .hg-row {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .simple-keyboard.fb-keyboard.japanese-middle.kana .hg-rows .hg-row {
    grid-template-columns: repeat(1, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr));
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button {
    margin-right: 0 !important;
    width: auto;
    height: 100%;
    box-shadow: none!important;
    border-radius: 0;
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider {
    max-width: 8px !important;
    min-width: 8px !important;
    flex-grow: 0 !important;
    flex-shrink: 0 !important;
    pointer-events: none !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    padding: 0 !important;
    margin: 0 6px !important;
    position: relative !important;
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider span {
    display: none !important;
  }

  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.active {
    background-color: #d1d5db !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Keyboard/Custom/Japanese/japanese.css"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB;gEAC4D;IAC5D,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,8EAA8E;EAChF;;EAEA;IACE,iDAAiD;EACnD;;EAEA;IACE,4GAA4G;EAC9G;;EAEA;IACE,0BAA0B;IAC1B,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;IACzB,+BAA+B;IAC/B,kCAAkC;IAClC,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;IACrB,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["@layer utilities {\n  .simple-keyboard.japanese-left {\n    width: 240px !important;\n  }\n\n  .simple-keyboard.japanese-right {\n    width: 240px !important;\n    /* Tall enough for the 5-row segment-navigation layout, so switching in and\n       out of it doesn't resize (and jump) the whole keyboard. */\n    min-height: 360px;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows {\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row {\n    gap: 2px;\n    height: 100%;\n    display: grid;\n    margin-bottom: 0;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle.numbers .hg-rows .hg-row {\n    grid-template-columns: repeat(5, minmax(0, 1fr)) 2px repeat(3, minmax(0, 1fr));\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle.abc .hg-rows .hg-row {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle.kana .hg-rows .hg-row {\n    grid-template-columns: repeat(1, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr)) 2px repeat(5, minmax(0, 1fr));\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button {\n    margin-right: 0 !important;\n    width: auto;\n    height: 100%;\n    box-shadow: none!important;\n    border-radius: 0;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider {\n    max-width: 8px !important;\n    min-width: 8px !important;\n    flex-grow: 0 !important;\n    flex-shrink: 0 !important;\n    pointer-events: none !important;\n    background: transparent !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n    padding: 0 !important;\n    margin: 0 6px !important;\n    position: relative !important;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.keyboard-divider span {\n    display: none !important;\n  }\n\n  .simple-keyboard.fb-keyboard.japanese-middle .hg-rows .hg-row .hg-button.active {\n    background-color: #d1d5db !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
